
import { Button } from "@/components/ui/button";

const PodRevolutionSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Hero section with background image */}
          <div className="relative mb-16 rounded-3xl overflow-hidden shadow-2xl min-h-[480px] md:min-h-[560px] lg:min-h-[600px]">
            {/* Background image */}
            <div className="absolute inset-0">
              <img 
                src="/lovable-uploads/82a356bf-3760-4438-a479-57dd743fefe6.png"
                alt="Security analyst working with AI systems"
                className="w-full h-full object-cover object-center"
              />
              {/* Gradient overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
            </div>
            
            {/* Content overlay - positioned to avoid face completely */}
            <div className="relative z-10 p-8 md:p-16 lg:p-20 text-white flex flex-col justify-between h-full">
              {/* Top left section with title - positioned away from face */}
              <div className="flex-1 flex flex-col justify-start max-w-2xl">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
                  Your AI Agent as 
                  <span className="block bg-gradient-to-r from-[#8932c8] to-[#b87ade] bg-clip-text text-transparent"> Next Teammate</span>
                </h2>
              </div>
              
              {/* Bottom left section with description and CTA - well clear of face */}
              <div className="flex flex-col justify-end max-w-3xl mt-auto">
                <p className="text-lg md:text-xl text-gray-200 leading-relaxed font-medium mb-6">
                  Consider an agent as your next teammate. Imagine the concept of a traditional pod in a SOC, but now 
                  broaden it to people working with AI agents in specialized, outcome-driven pods.
                </p>
                
                <div className="flex justify-start">
                  <Button 
                    size="cta" 
                    className="bg-[#8932c8] hover:bg-[#722ba1] text-white rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
                  >
                    Transform Your SOC Today
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-white to-slate-50 rounded-3xl shadow-2xl border border-gray-200 p-8 md:p-12">
            <h3 className="text-3xl font-bold mb-10 text-center">Specialized Aura XP Agents</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
                <h4 className="text-xl font-bold mb-4">Phishing Triage Agent</h4>
                <p className="text-gray-600 leading-relaxed">Specialized in email threat analysis and response</p>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
                <h4 className="text-xl font-bold mb-4">Lateral Movement Detection</h4>
                <p className="text-gray-600 leading-relaxed">Focused on identifying advanced persistent threats</p>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
                <h4 className="text-xl font-bold mb-4">Insider Threat Agent</h4>
                <p className="text-gray-600 leading-relaxed">Dedicated to internal security risk assessment</p>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-[#8932c8]/5 to-[#b87ade]/5 rounded-2xl p-8 border border-[#8932c8]/20">
              <div className="flex items-start gap-4 mb-6">
                <h4 className="text-xl font-bold text-[#8932c8]">Unlike traditional playbooks, these agents are built to learn, adapt, and act autonomously:</h4>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#8932c8] rounded-full"></div>
                    <span className="text-gray-700 text-lg">Remember past decisions and context</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#8932c8] rounded-full"></div>
                    <span className="text-gray-700 text-lg">Adapt based on new threat intelligence</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#8932c8] rounded-full"></div>
                    <span className="text-gray-700 text-lg">Recommend actions with explainable logic</span>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#8932c8] rounded-full"></div>
                    <span className="text-gray-700 text-lg">Analyst becomes the lead strategist</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#8932c8] rounded-full"></div>
                    <span className="text-gray-700 text-lg">Validates critical steps and mentors decisions</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#8932c8] rounded-full"></div>
                    <span className="text-gray-700 text-lg">Over time, agents become faster and better</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PodRevolutionSection;
